import React from 'react'

const styles = {
  fontSize: {
    fontSize: '12px',
  },
}

function DisplayArticleDetails(props) {
  return (
    <div
      draggable={true}
      id={props.index}
      SK={props.item.SK}
      articlestatus={props.item.newsarticleStatus}
      onDragOver={(ev) => ev.preventDefault()}
      onDragStart={(ev) => props.handleDrag(ev)}
      onDrop={(ev) => props.handleDrop(ev)}
      key={`article${props.index}${props.item.SK}`}
      class='list-group mb-2'
    >
      <a
        target='_blank'
        class='list-group-item list-group-item-action '
        style={{
          backgroundColor: props.displayBackgroundColor,
        }}
      >
        <div
          class='d-flex w-100 mb-2 '
          onClick={(e) => {
            props.selectArticles(e, props.item.newsarticleStatus, props.index, props.item)
          }}
        >
          <div class='w-100 '>
            <div class='d-flex w-100 justify-content-between '>
              <small class='smallFontSize'>{props.item.siteName}</small>
              <small class='smallFontSize'>{props.item.category}</small>
              <small class='smallFontSize'>{props.createdDate}</small>
            </div>
            <div class='articleDetails'>
              <div class='articleTitleDetails'>
                <p class='mb-1 articleTitle'>
                  <a href={props.item.newsarticleURL} target='_blank'>
                    {props.item.title.slice(0, 150)}
                  </a>
                </p>
                {props.item.shortTitle ? (
                  <p class='mb-1 articleDescription'>
                    {props.item.shortTitle.slice(0, 150)}
                    {'...'}
                  </p>
                ) : null}
              </div>
            </div>
          </div>
        </div>
        <small class='articleMoreOptions'>
          <i
            onClick={() => {
              props.openModalAndSetData(props.item, props.index, props.type)
            }}
            class=' fas fa-ellipsis-h'
          />
        </small>

        {/* <div
          class='d-flex w-100 '
          onClick={(e) => {
            props.selectArticles(e, props.item.newsarticleStatus, props.index, props.item)
          }}
        >
          <small>{props.item.category}</small>
        </div>
        <div class='d-flex w-100 justify-content-between'>
          <small class='createdDate'>{props.createdDate}</small>

          <small>
            <i
              onClick={() => {
                props.openModalAndSetData(props.item, props.index, props.type)
              }}
              class='fas fa-ellipsis-h'
              style={{
                padding: '10px',
              }}
            />
          </small>
        </div> */}
      </a>
    </div>
  )
}

export default DisplayArticleDetails
